import React from "react";
import "./App.css";
import HeroSection from "./components/HeroSection";
import WhatWeBuilding from "./components/WhatWeBuilding";
import MarketplaceUnitEconomics from "./components/MarketplaceUnitEconomics";
import OurMoat from "./components/OurMoat";
import AgenticArchitecture from "./components/AgenticArchitecture";
import MarketplaceBrands from "./components/MarketplaceBrands";
import Footer from "./components/Footer";

function App() {
  return (
    <div className="App min-h-screen bg-white relative">
      {/* Unicorn Background */}
      <div 
        className="fixed inset-0 z-0"
        style={{
          backgroundImage: 'url(/unicorn-background.png)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          opacity: 0.15
        }}
      />
      <main className="relative z-10">
        <HeroSection />
        <WhatWeBuilding />
        <AgenticArchitecture />
        <MarketplaceUnitEconomics />
        <OurMoat />
        <MarketplaceBrands />
      </main>
      <Footer />
    </div>
  );
}

export default App;
